import { Component } from "@angular/core";

@Component({
    selector: "bar-chart-selector-legend-modifier",
    template: "<style>:host >>> .chart-legend-custom { width: 60% !important; margin-left: 40% !important; }</style><ng-content></ng-content>",
    standalone: false
})
export class BarChartSelectorLegendModifierComponent
{

}